import { render, staticRenderFns } from "./streamTv_ReleaseDetails.vue?vue&type=template&id=b7b63eba&"
import script from "./streamTv_ReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./streamTv_ReleaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./streamTv_ReleaseDetails.vue?vue&type=style&index=0&id=b7b63eba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports